<template>
    <div class="sprouter-label" 
         :class="{ active: isActive, lighten:lighten }"
         @mouseover="hover = true"
         @mouseleave="hover = false">
        {{ labelName }}
    </div>
</template>

<script>
export default {
    name: 'GenerationLabel',
    props: ["labelName", "isActive"],
    data: function() {
        return {
            hover: false
        }
    },
    computed: {
        lighten: function() {
            if (this.hover) {
                if (this.isActive) {
                    return false;
                }
                return true;
            }
            return false;
        }
    }
}
</script>

<style scoped 
       lang="scss">
    @import "../../static/styles/palette.scss";

    .sprouter-label {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 10px;
        min-width: 100px;
        height: 30px;
        border-style: solid;
        border-width: 5px; 
        border-radius: 30px;
        border-color: $blue;
        cursor: pointer;
        font-family: "Fugaz One";       
        letter-spacing: 1px;        
        color: $blue;
    }

    .sprouter-label.active {
        background-color: $blue;
        color: white;
    }
    .sprouter-label.lighten {
        background-color: $blue;
        opacity: 0.75;
        color: white;
    }

    @media all and (max-width: 480px) {
        .sprouter-label {
            margin: 5px;
            width: 70px;
            height: 25px;
            font-size: 14px;
            border-width: 4px;
        }
    }

    @media all and (max-width: 320px) {
        .sprouter-label {
            margin: 5px;
            width: 60px;
            height: 25px;
            font-size: 12px;
            border-width: 3px;
        }
    }
</style>



// WEBPACK FOOTER //
// Label.vue?6865129a